import { Attr, BelongsTo, HasMany, HasOne, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type FilterSet from "./FilterSet";
import type Organisation from "./Organisation";
import type QuerySnippetGroup from "./QuerySnippetGroup";
import type QuerySnippetLink from "./QuerySnippetLink";

@Model()
class QuerySnippet extends ApplicationRecord {
  static jsonapiType = "query_snippets";

  @Attr({ persist: false }) archivedAt: string;

  @Attr() booleanQuery: string;

  @Attr({ persist: false }) code: string;

  @Attr() enabledMedia: string;

  @Attr({ persist: false }) filterSetIds: number[];

  @HasMany() filterSets: FilterSet[];

  @HasOne() group: QuerySnippetGroup;

  @Attr() groupId: number;

  @Attr() invalidQuery: boolean;

  @Attr() label: string;

  @Attr() notes: string;

  @BelongsTo() organisation: Organisation;

  @Attr() organisationId: number;

  @Attr() position: number;

  @HasMany() querySnippetLinks: QuerySnippetLink[];

  @Attr() querySnippetLinksCount: number;
}

export default QuerySnippet;
